import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

export type PatchProfileParams = {
  profileId: number;
  _type?: "entity" | "individual";
  first_name?: string;
  middle_name?: string | null;
  last_name?: string;
  gender?: "male" | "female" | "other" | null;
  date_of_birth?: string | null;
  name?: string;
  entity_type?: number | null;
  company_status?: number | null;
  registration_number?: string | null;
  date_of_incorporation?: string | null;
  country?: number | null;
  email?: string | null;
  external_reference?: string | null;
  owner?: number | null;
  reviewer?: number | null;
  periodic_review?: string | null;
  periodic_review_date?: string | null;
  /** Full replacement lists of shared Division/Team ids (sharing panel). */
  additional_divisions?: number[];
  additional_teams?: number[];
  nature_of_business?: {
    id?: number;
    description: string | null;
    industry: number[];
    sector: number[];
  }[];
};

export const usePatchProfile = () => {
  const { authHeader } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ profileId, ...rest }: PatchProfileParams) => {
      const payload = Object.fromEntries(
        Object.entries(rest).filter(([, value]) => value !== undefined)
      );

      return axios.patch(
        `${env.verifyServiceUrl}individual/profile/${profileId}/`,
        payload,
        {
          headers: {
            Authorization: authHeader,
          },
        }
      );
    },

    onSuccess: async (_data, vars) => {
      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: ["profile", vars.profileId],
        });
      }, 0);
    },
  });
};
